// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"232214eb","676":"232214eb"}[chunkId] + ".chunk.css";
};